import * as _ from 'lodash';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile, map } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as moment from 'moment';

import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';

import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as BookingStepActions from '@ibe/store/actions/booking-steps.actions';
import * as FlightResultActions from '@ibe/store/actions/flight-result.actions';

import { BookingStep } from '@ibe/models/ui';
import { BookedTrip, Flight, PassengerFlightInfo } from '@ibe/models';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';
import { INDRAFlightPrice } from '@ibe.models/flight-price.model.indra.lib';

import { ModalService, SidebarService } from '@ibe/services/ui';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';

import {
	TRIP_TYPE_MULTICITY_CODE,
	EQUIPMENT_CODE_BUS,
	DISCOUNT_STATUS_ACTIVE,
	DISCOUNT_TYPE_VOUCHER,
	DISCOUNT_TYPE_PROMOCODE,
	DISCOUNT_AMOUNT_TYPE_FIXED,
	DISCOUNT_AMOUNT_TYPE_PERCENTAGE,
	TRANSLATION_INSURANCE,
	ANCILLARY_PRODUCT_LOUNGE,
	ANCILLARY_PRODUCT_FAST_TRACK,
	ANCILLARY_PRODUCT_SEAT,
	ANCILLARY_PRODUCT_MEAL,
	ANCILLARY_PRODUCT_BAGGAGE,
	ANCILLARY_PRODUCT_PACK_PAAG,
	ANCILLARY_PRODUCT_PACK_PAAD,
	ANCILLARY_PRODUCT_PACK_PAAE,
	ANCILLARY_PRODUCT_PACK_PAAF,
	ANCILLARY_PRODUCT_PACK_PAAC,
	ANCILLARY_PRODUCT_PACK_PAAH,
	ANCILLARY_PRODUCT_PACK_PAAB,
	ANCILLARY_PRODUCT_PACK_PAAA,
	ANCILLARY_PRODUCT_PACK_PAAI,
	ANCILLARY_PRODUCT_PACK_PAAQ,
	EXTRAS_ANCILLARY_SEAT,
	EXTRAS_ANCILLARY_ANIMAL,
	EXTRAS_ANCILLARY_MUSICAL,
	EXTRAS_ANCILLARY_EQUIPMENT,
	EXTRAS_ANCILLARY_BAG,
	SSR_CODE_BAGGAGE_ADDITIONAL_BAG,
	TTT_STATUS_ACTIVE,
	ANCILLARY_PRODUCT_PREF_BOARD,
	ANCILLARY_PRODUCT_PACKS
} from '@ibe.config';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';



@Component({
	selector: 'app-booking-price-breakdown-new',
	templateUrl: './booking-price-breakdown-new.indra.component.html',
	styleUrls: ['./booking-price-breakdown-new.component.scss']
})
export class INDRABookingPriceBreakdownNewComponent implements OnInit, OnDestroy {
	private isAlive = true;

	STOPOVER_LINKS = [
		{
			id: 'hotel',
			label: 'Hotel',
			description: '',
			type: 'extra',
			action: { label: 'Add', route: 'partner-hotel' },
			icon: 'destinations--adventure',
			active: false
		},
		{
			id: 'lisboa-card',
			label: 'Lisboa card discount voucher',
			description: '',
			type: 'extra',
			action: { label: 'Add', route: 'lisboa-card-discount' },
			icon: 'services--book_hotel',
			active: false
		},
		{
			id: 'sightseeing-tours',
			label: 'Sightseeing tours',
			description: '',
			type: 'extra',
			action: { label: 'Add', route: 'sightseeing-tours' },
			icon: 'destinations--tours_activities',
			active: false
		},
		{
			id: 'airport-transfers',
			label: 'Airport transfers',
			description: '',
			type: 'extra',
			action: { label: 'Add', route: 'airport-transfers' },
			icon: 'transportation--bus',
			active: false
		},
		{
			label: 'Download Stopover app',
			description: '',
			type: 'extra',
			details: { label: 'Learn More', route: 'sports-equipment' },
			icon: 'digital_universe--mobile_phone',
			active: false
		},
		{
			label: '',
			description: '',
			type: 'extra',
			icon: null,
			details: {
				label: 'All Stopover Experiences and Discounts',
				route: 'ancillaries--sports_equipment'
			}
		}
	];

	VOUCHER_DISCOUNT = DISCOUNT_TYPE_VOUCHER;
	PROMOCODE_DISCOUNT = DISCOUNT_TYPE_PROMOCODE;
	FIXED_TYPE_DISCOUNT = DISCOUNT_AMOUNT_TYPE_FIXED;
	PERCENTAGE_TYPE_DISCOUNT = DISCOUNT_AMOUNT_TYPE_PERCENTAGE;

	bookAwardFlights$: Observable<boolean> = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
	bookAwardFlights: boolean = false;

	bookingSteps$: Observable<BookingStep[]> = this.store.select(fromStore.getSelectedBookingSteps);
	bookingSteps: BookingStep[];

	bookedTrip$: Observable<BookedTrip> = this.store.select(fromStore.getSelectedBookedTrip);
	bookedTrip;

	userInfo$: Observable<Object> = this.store.select(fromStore.getUserInfo);
	userInfo: any;
	userMiles: number;
	isUserLoggedIn: boolean;

	bookedTripDiscounts$: Observable<any> = this.store.select(fromStore.getSelectedBookedTripDiscounts);
	bookedTripDiscounts: Array<any> = [];

	promocoCodesAndVoucher$: Observable<Array<any>> = this.store.select(fromStore.getSelectedPromoVouchers);
	promocoCodesAndVoucher: Array<any> = [];

	milesInFlightDiscount$: Observable<any> = this.store.select(fromStore.getMilesInFlightDiscount);
	milesInFlightDiscount: any;

	bookedTripExtras$: Observable<Array<any>> = this.store.select(fromStore.getSelectedBookedTripExtras);
	bookedTripExtras: Array<any> = [];

	confirmModalCallback$: Observable<string> = this.store.select(fromStore.getConfirmModalConfirm);
	confirmModalCallback = '';

	
    triggerHppRedFlag$: Observable<boolean> = this.indraPaymentService.triggerHppRedFlag$;
	triggerHppRedFlag: boolean = false;

	booked_trip: INDRABookedTripDetails;
	booked_trip_flights: Array<any> = [];
	flight_tickets: Array<any> = [];
	tripType: string;
	pnr: string;
	userData: any;

	ancillaries: Array<any> = [];
	extra_stopover: Array<any> = [];

	bookedHotels: Array<any> = [];
	bookedTripExtrasTotalPrice: number = 0;
	bookedTripExtrasCurrency: string;

	bookedCarRentals: Array<any> = [];
	bookedCarRentalTotalPrice: number = 0;

	carbonOffset: any;
	carbonOffsetCurrency: any;

	insurance: any;
	insuranceCurrency: string;
	translationInsurance = TRANSLATION_INSURANCE;

	danishGuaranteeFund: any;
	danishFundCurrency: string;

	isBookedTripLoaded: boolean = false;
	hasBookedTripRetrievalError: boolean = false;
	hasVoucherOrPromocode: boolean = false; // TODO 
	isTTTBookingForCompletion: boolean = false;
	isNormalBookingOrActiveTTT: boolean = false;
	isDupe: boolean = false;
	hasStopover: boolean = false;
	isBookingAlreadyCreated: boolean = false;

	totalBookingMilesToPay;
	totalBookingCashToPay;
	totalFlightPrice;
	totalDiscount;
	totalAncillariesPrice;
	totalOtherCharges: number;
	currency: string;
	currencyUnit;
	adminFee: number = 0;
	ccFee: number = 0; // aka surcharge for BR market card payments of flights
	
	state: 'expanded' | 'collapsed' = 'collapsed';
	taxCarbonSummary = [];

	showChangeFlightOption: boolean = true;

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private store: Store<fromStore.State>,
		private modalService: ModalService,
		private currencyService: INDRACurrencyService,
		private bookingSearchService: INDRABookingSearchService,
		protected bookingService: INDRABookingService,
		protected ibeAdminService: INDRAIbeAdminService,
		protected ancillariesService: INDRAAncillariesService,
		private bfmStorage: INDRABFMDataStorageService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		private indraPaymentService: INDRAPaymentService,
	) {

		this.bookAwardFlights$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.bookAwardFlights = value;
			});

		this.bookingSteps$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((value) => {
				if (value) {
					this.bookingSteps = value;
				}
			});

		this.bookedTrip$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.bookedTrip = value;
					this.isNormalBookingOrActiveTTT = this.INDRA_isNormalBookingOrActiveTTT(this.bookedTrip);
				}
			});

		this.userInfo$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((value: any) => {
				this.isUserLoggedIn = value;
				this.userMiles = value && value['currentPoints'] ? value['currentPoints'] : 0;
				if (value) {
					this.userInfo = value;
				}
			});

		this.bookedTripDiscounts$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(discounts => {
				this.bookedTripDiscounts = Object.assign([], discounts);
			});

		this.promocoCodesAndVoucher$
			.pipe(
				takeWhile(() => this.isAlive),
				map(value => value && value.filter(discount => discount.status === DISCOUNT_STATUS_ACTIVE))
			)
			.subscribe(discounts => {
				if (discounts && discounts.length != 0) {
					this.promocoCodesAndVoucher = Object.assign([], discounts);
					this.hasVoucherOrPromocode = true;
				} else {
					this.promocoCodesAndVoucher = [];
					this.hasVoucherOrPromocode = false;
				}
			});

		this.milesInFlightDiscount$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				if (value) {
					this.milesInFlightDiscount = value;
				}
			});

		this.bookedTripExtras$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(extras => {
				if (extras) {
					this.bookedTripExtras = extras;
				} else {
					this.bookedTripExtras = [];
				}
			});

		this.confirmModalCallback$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((value) => {
				if (value) {
					this.confirmModalCallback = value;
				}
			});

		this.triggerHppRedFlag$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {
				this.triggerHppRedFlag = value;
			});

	}

	ngOnInit() {
		this.showChangeFlightOption = true;
		if (this.router.url.includes('/booking/payment')) {
			this.showChangeFlightOption = false;
		}

		// check if flow is TTT booking completion
		const isTTTBookingForCompletion = this.route.snapshot.paramMap.get('isTTTBookingForCompletion');
		this.isTTTBookingForCompletion = (isTTTBookingForCompletion == null || isTTTBookingForCompletion === 'false') ? false : true;

		// check if sidebar was opened for Dupe scenario
		const isDupeParam = this.route.snapshot.paramMap.get('isDupe');
		if (isDupeParam == null || isDupeParam === 'false') {
			this.isDupe = false;
		} else {
			this.isDupe = true;
		}

		// query param value from the URL to identify whether the booking has been created or not
		const bookingCreatedParamValue = this.route.snapshot.paramMap.get('isBookingCreated');
		if (bookingCreatedParamValue == null || bookingCreatedParamValue === 'false') {
			this.isBookingAlreadyCreated = false;
		} else {
			this.isBookingAlreadyCreated = true;
		}

		if (!this.isDupe) {
			/**** get booking details ****/
			this.isBookedTripLoaded = false;
			this.bookingSearchService.INDRA_generateTemporaryPNR().subscribe(res => {
				if (!res || !res.data) {
					this.isBookedTripLoaded = true;
					this.hasBookedTripRetrievalError = true;
					return;
				} else {
					this.isBookedTripLoaded = true;
					this.hasBookedTripRetrievalError = false;

					this.booked_trip = new INDRABookedTripDetails(res);
					this.setPricebreakdownDetails();
				}
			}, err => {
				this.isBookedTripLoaded = true;
				this.hasBookedTripRetrievalError = true;
			});
		} else {
			/**** get booking details from dupe booked_trip ****/
			this.isBookedTripLoaded = true;
			this.hasBookedTripRetrievalError = false;

			this.booked_trip = this.bfmStorage.INDRA_getDupeBookedTrip();
			this.setPricebreakdownDetails();
		}
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	// get then set all booking details to be displayed on the price breakdown sidebar
	private setPricebreakdownDetails() {
		this.currency = this.booked_trip.data.fare.currency;
		this.currencyUnit = this.currencyService.INDRA_getCurrencySymbol(this.currency).unit;
		this.tripType = this.booked_trip.data.fare.tripType;
		this.pnr = this.booked_trip.data.pnr;
		this.hasStopover = this.INDRA_checkForStopovers(this.booked_trip);

		this.flight_tickets = this.INDRA_getTripFlights(this.booked_trip);
		this.booked_trip_flights = this.flight_tickets.filter(ticket => ticket.type === 'flight');


		this.adminFee = this.booked_trip.data.fare && this.booked_trip.data.fare.originalFlightPrice
			&& this.booked_trip.data.fare.originalFlightPrice.totalPrice && this.booked_trip.data.fare.originalFlightPrice.totalPrice.adminFee
			&& this.booked_trip.data.fare.originalFlightPrice.totalPrice.adminFee.amount ?
			this.booked_trip.data.fare.originalFlightPrice.totalPrice.adminFee.amount : 0;
		this.ccFee = this.booked_trip.data.fare && this.booked_trip.data.fare.flightPrice
			&& this.booked_trip.data.fare.flightPrice.totalPrice && this.booked_trip.data.fare.flightPrice.totalPrice.ccFee ?
			this.booked_trip.data.fare.flightPrice.totalPrice.ccFee : 0;

		this.INDRA_setThirdPartyExtras(this.booked_trip);

		if (this.hasStopover) {
			this.INDRA_setStopoverExtras(this.booked_trip, this.currency);
		}

		// set up TAP ancillaries
		this.INDRA_getAncillaries(this.booked_trip, this.flight_tickets, this.hasStopover);

		// **** compute for prices ****/
		this.INDRA_computeBookingTotalPrice(this.booked_trip, this.hasVoucherOrPromocode, this.currency);
		this.totalFlightPrice = this.INDRA_computeFlightTotalPrice(this.booked_trip, this.hasVoucherOrPromocode, this.currency);
		this.totalDiscount = this.INDRA_getTotalDiscounts(this.booked_trip, this.hasVoucherOrPromocode, this.currency);
		this.totalAncillariesPrice = this.INDRA_getAncillariesTotalPrice(this.currency);
		this.totalOtherCharges = this.INDRA_computeOtherPrices();
	}

	private INDRA_checkForStopovers(booked_trip) {
		let hasStopover = false;
		if (booked_trip.data.fare.listOutbound.filter(outbound => outbound.isStopOver).length > 0) {
			hasStopover = true;
		}
		if (!hasStopover && booked_trip.data.fare.listInbound.filter(inbound => inbound.isStopOver).length > 0) {
			hasStopover = true;
		}
		return hasStopover;
	}

	private INDRA_getTripFlights(booked_trip) {
		const tripType = booked_trip.data.fare.tripType;
		let tripFlights = [];
		let key = 0;

		// outbound flights
		let isPreviousBoundStopover = false;
		booked_trip.data.fare.listOutbound.forEach((outbound, index) => {
			const outboundLength = outbound.listSegment.length;
			const isFirstBoundObject = (index === 0) ? true : false;
			tripFlights.push({
				type: 'flight',
				id: 'flight-' + key,
				item: {
					details: outbound,
					departureLocation: booked_trip.translate.locations[outbound.listSegment[0].departureAirport],
					arrivalLocation: booked_trip.translate.locations[outbound.listSegment[outboundLength - 1].arrivalAirport],
					airLinesTranslation: booked_trip.translate.airlines,
					flightDate: this.INDRA_setFlightDate(outbound),
					logo: this.INDRA_setAirlineLogo(outbound),
					price: this.INDRA_setFlightPrice(outbound, tripType, isFirstBoundObject, isPreviousBoundStopover),
          isNonZeroPrice: outbound && outbound.totalPrice && outbound.totalPrice.price !== 0
				},
			});

			isPreviousBoundStopover = outbound.isStopOver ? true : false;
			key++;
		});

		// inbound flights
		if (booked_trip.data.fare.listInbound) {
			isPreviousBoundStopover = false;
			booked_trip.data.fare.listInbound.forEach((inbound, index) => {
				const inboundLength = inbound.listSegment.length;
				const isFirstBoundObject = (index === 0) ? true : false;
				tripFlights.push({
					type: 'flight',
					id: 'flight-' + key,
					item: {
						details: inbound,
						departureLocation: booked_trip.translate.locations[inbound.listSegment[0].departureAirport],
						arrivalLocation: booked_trip.translate.locations[inbound.listSegment[inboundLength - 1].arrivalAirport],
						airLinesTranslation: booked_trip.translate.airlines,
						flightDate: this.INDRA_setFlightDate(inbound),
						logo: this.INDRA_setAirlineLogo(inbound),
						price: this.INDRA_setFlightPrice(inbound, tripType, isFirstBoundObject, isPreviousBoundStopover),
            isNonZeroPrice: inbound && inbound.totalPrice && inbound.totalPrice.price !== 0
					}
				});

				isPreviousBoundStopover = inbound.isStopOver ? true : false;
				key++;
			});
		}
		return tripFlights;
	}

	private INDRA_setFlightDate(bound): string {
		if (bound) {
			const date = moment(new Date(bound.listSegment[0].departureDate.slice(0, -5)));
			const dateTime = date.format('D - kk:mm');
			let day = date.format('dddd').toLowerCase();
			let month = date.format('MMMM').toLowerCase();

			day = this.INDRA_getTranslation('dates.text.' + day);
			month = this.INDRA_getTranslation('dates.text.' + month);

			return `${day.substring(0, 3)}, ${month.substring(0, 3)} ${dateTime}`;
		}
	}

	private INDRA_setAirlineLogo(bound) {
		let airlineLogo;
		const busSegmentCount = bound.listSegment.filter(segment => segment.equipment === EQUIPMENT_CODE_BUS).length;
		if (busSegmentCount > 0) {
			return 'icons.svg#plane_related--plane_and_bus';
		} else {
			if (bound.listSegment.length > 1) {
				const ALL_SAME_AIRLINE = bound.listSegment.every((val, i, arr) => val.operationCarrier === arr[0].operationCarrier);
				if (ALL_SAME_AIRLINE) {
					airlineLogo = bound.listSegment[0].operationCarrier;
				} else {
					airlineLogo = 'Multiple';
				}
			} else {
				airlineLogo = bound.listSegment[0].operationCarrier;
			}
			return this.bookingSearchService.INDRA_buildAirlineLogoName(airlineLogo);
		}
	}

	private INDRA_setFlightPrice(bound, tripType, isFirstBoundObject, isPreviousBoundStopover) {
		if (isPreviousBoundStopover || (tripType === TRIP_TYPE_MULTICITY_CODE && !isFirstBoundObject)) {
			return new INDRAFlightPrice(0, 0, this.currencyUnit, false).getFlightCost();
		} else {
			if (this.bookAwardFlights) {
				const tax = bound.totalPrice && bound.totalPrice.tax ? bound.totalPrice.tax : 0;
				const obFee = bound.totalPrice && bound.totalPrice.obFee ? bound.totalPrice.obFee : 0;
				const milesPrice = bound.totalPoints && bound.totalPoints.price ? bound.totalPoints.price : 0;
				return new INDRAFlightPrice(milesPrice, (tax + obFee), this.currencyUnit, this.bookAwardFlights).getFlightCost();
			} else {
				const cashPrice = bound.totalPrice && bound.totalPrice.price ? bound.totalPrice.price : 0;
				return new INDRAFlightPrice(cashPrice, 0, this.currencyUnit, false).getFlightCost();
			}
		}
	}

	private INDRA_computeFlightTotalPrice(booked_trip, hasVoucherOrPromocode, currency) {
		// if has voucher discount, get price from originalFlightPrice; if not, otherwise get from flightPrice
		if (hasVoucherOrPromocode) {
			const currencyUnit = booked_trip.data.fare.originalFlightPrice && booked_trip.data.fare.originalFlightPrice.totalPrice &&
				booked_trip.data.fare.originalFlightPrice.totalPrice.currency ?
				this.currencyService.INDRA_getCurrencySymbol(booked_trip.data.fare.originalFlightPrice.totalPrice.currency).unit :
				this.currencyService.INDRA_getCurrencySymbol(currency).unit;
			if (this.bookAwardFlights) {
				const tax = booked_trip.data.fare.originalFlightPrice && booked_trip.data.fare.originalFlightPrice.totalPrice &&
					booked_trip.data.fare.originalFlightPrice.totalPrice.tax ? booked_trip.data.fare.originalFlightPrice.totalPrice.tax : 0;
				const obfee = booked_trip.data.fare.originalFlightPrice && booked_trip.data.fare.originalFlightPrice.totalPrice &&
					booked_trip.data.fare.originalFlightPrice.totalPrice.obFee ? booked_trip.data.fare.originalFlightPrice.totalPrice.obFee : 0;
				const milesPrice = booked_trip.data.fare.originalFlightPrice && booked_trip.data.fare.originalFlightPrice.totalPoints &&
					booked_trip.data.fare.originalFlightPrice.totalPoints.price ? booked_trip.data.fare.originalFlightPrice.totalPoints.price : 0;
				return new INDRAFlightPrice(milesPrice, (tax + obfee), currencyUnit, this.bookAwardFlights).getFlightCost();
			} else {
				const cashPrice = booked_trip.data.fare.originalFlightPrice && booked_trip.data.fare.originalFlightPrice.totalPrice &&
					booked_trip.data.fare.originalFlightPrice.totalPrice.price ? booked_trip.data.fare.originalFlightPrice.totalPrice.price : 0;
				return new INDRAFlightPrice(cashPrice, 0, currencyUnit, false).getFlightCost();
			}
		} else {
			const currencyUnit = booked_trip.data.fare.flightPrice && booked_trip.data.fare.flightPrice.totalPrice &&
				booked_trip.data.fare.flightPrice.totalPrice.currency ?
				this.currencyService.INDRA_getCurrencySymbol(booked_trip.data.fare.flightPrice.totalPrice.currency).unit :
				this.currencyService.INDRA_getCurrencySymbol(currency).unit;
			if (this.bookAwardFlights) {
				const tax = booked_trip.data.fare.flightPrice && booked_trip.data.fare.flightPrice.totalPrice &&
					booked_trip.data.fare.flightPrice.totalPrice.tax ? booked_trip.data.fare.flightPrice.totalPrice.tax : 0;
				const obfee = booked_trip.data.fare.flightPrice && booked_trip.data.fare.flightPrice.totalPrice &&
					booked_trip.data.fare.flightPrice.totalPrice.obFee ? booked_trip.data.fare.flightPrice.totalPrice.obFee : 0;
				const milesPrice = booked_trip.data.fare.flightPrice && booked_trip.data.fare.flightPrice.totalPoints &&
					booked_trip.data.fare.flightPrice.totalPoints.price ? booked_trip.data.fare.flightPrice.totalPoints.price : 0;
				return new INDRAFlightPrice(milesPrice, (tax + obfee), currencyUnit, this.bookAwardFlights).getFlightCost();
			} else {

				let cash = booked_trip.data.fare.flightPrice && booked_trip.data.fare.flightPrice.totalPrice &&
					booked_trip.data.fare.flightPrice.totalPrice.price ? booked_trip.data.fare.flightPrice.totalPrice.price : 0;
				let cashPrice = new INDRAFlightPrice(cash, 0, currencyUnit, false).getFlightCost();
				let miles = booked_trip.data.fare.flightPrice && booked_trip.data.fare.flightPrice.totalPoints &&
					booked_trip.data.fare.flightPrice.totalPoints.price ? booked_trip.data.fare.flightPrice.totalPoints.price : 0;
				let milesAllowanceConfig = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.initialMilesAllowance');
				let initialMilesAllowance: number = milesAllowanceConfig && !isNaN(parseFloat(milesAllowanceConfig)) ? -(Number(milesAllowanceConfig)) : -1800;

				let deficitMiles = this.isUserLoggedIn ? this.userMiles - miles : miles;
				let milesAllowance = this.bookAwardFlights ? 0 : initialMilesAllowance;


				if (this.isUserLoggedIn && deficitMiles < milesAllowance) {
					cash = booked_trip.data.fare.bookingTotal.amount;
					miles = 0;
					cashPrice = new INDRAFlightPrice(cash, 0, currencyUnit, false).getFlightCost();
				}
				else {
					// override prices from API if has mgp1 discount AND mgp1 == flight milesgo discount in store (and no promocode/voucher) AND totalPoints.price from API is NULL or 0
					const initialMGDiscount =
						this.bookedTripDiscounts && this.bookedTripDiscounts.length > 0 && this.bookedTripDiscounts[0] && this.bookedTripDiscounts[0].value ?
							this.bookedTripDiscounts[0].value : 0;
					const milesInFlightDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.miles ? this.milesInFlightDiscount.miles : 0;
					const cashDiscountEquivalentOfMilesDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.cash ? this.milesInFlightDiscount.cash : 0;

					if (miles == 0 && (initialMGDiscount > 0 && cashDiscountEquivalentOfMilesDiscount > 0 && initialMGDiscount === cashDiscountEquivalentOfMilesDiscount)) {
						miles = milesInFlightDiscount;
						cash = cash - initialMGDiscount;
						cashPrice = new INDRAFlightPrice(cash, 0, currencyUnit, false).getFlightCost();
					}
				}

				if(this.isUserLoggedIn && this.userMiles < 0){
					return this.booked_trip_flights[0].item.price;
				} else if (miles > 0) {
					return miles.toFixed(0) + 'M + ' + cashPrice;
				} else {
					return cashPrice;
				}
			}
		}
	}

	private INDRA_computeBookingTotalPrice(booked_trip, hasVoucherOrPromocode, currency) {
		this.totalBookingMilesToPay;
		this.totalBookingCashToPay;
		if (hasVoucherOrPromocode || this.bookAwardFlights) {
			const currencyUnit = booked_trip.data.fare.bookingTotal && booked_trip.data.fare.bookingTotal.currency ?
				this.currencyService.INDRA_getCurrencySymbol(booked_trip.data.fare.bookingTotal.currency).unit :
				this.currencyService.INDRA_getCurrencySymbol(currency).unit;
			const miles = booked_trip.data.fare.bookingTotal && booked_trip.data.fare.bookingTotal.miles ? booked_trip.data.fare.bookingTotal.miles : 0;
			const cash = booked_trip.data.fare.bookingTotal && booked_trip.data.fare.bookingTotal.amount ? booked_trip.data.fare.bookingTotal.amount : 0;
			if (miles == 0) {
				this.totalBookingCashToPay = `${cash.toFixed(2)} ${currencyUnit}`;
			} else {
				this.totalBookingCashToPay = `${cash.toFixed(2)} ${currencyUnit}`;
				if(this.userMiles >= 0){
					this.totalBookingMilesToPay = `${miles.toFixed(0)} M`
				}
				
			}
		} else {
			const currencyUnit = booked_trip.data.fare.bookingTotal && booked_trip.data.fare.bookingTotal.currency ?
				this.currencyService.INDRA_getCurrencySymbol(booked_trip.data.fare.bookingTotal.currency).unit :
				this.currencyService.INDRA_getCurrencySymbol(currency).unit;
			let miles = booked_trip.data.fare.bookingTotal && booked_trip.data.fare.bookingTotal.miles ? booked_trip.data.fare.bookingTotal.miles : 0;
			let cash = booked_trip.data.fare.bookingTotal && booked_trip.data.fare.bookingTotal.amount ? booked_trip.data.fare.bookingTotal.amount : 0;
			let milesAllowanceConfig = this.ibeAdminConfigService.getConfigurationValue('bookingPayment.initialMilesAllowance');
			let initialMilesAllowance: number = milesAllowanceConfig && !isNaN(parseFloat(milesAllowanceConfig)) ? -(Number(milesAllowanceConfig)) : -1800;

			let deficitMiles = this.isUserLoggedIn ? this.userMiles - this.milesInFlightDiscount.miles : this.milesInFlightDiscount.miles;
			let milesAllowance = this.bookAwardFlights ? 0 : initialMilesAllowance;

			if (this.isUserLoggedIn && deficitMiles < milesAllowance) {
				cash = booked_trip.data.fare.bookingTotal.amount;
				miles = 0;
			}
			else {
				// Override prices from API if has mgp1 discount AND mgp1 == flight milesgo discount in store (and no promocode/voucher) AND bookingTotal.miles from API is NULL or 0.
				// Note thatwe are also considering if there are ancillaries paid with miles (bookingTotal.miles from API is NOT NULL and NOT 0) 
				// but still does not include the mgp1 miles discount (we are using flightMilesCostFromAPI variable from booked_trip.data.fare.flightCost.miles 
				// to know that mgp1 is not applied on the flight cost)
				const initialMGDiscount =
					this.bookedTripDiscounts && this.bookedTripDiscounts.length > 0 && this.bookedTripDiscounts[0] && this.bookedTripDiscounts[0].value ?
						this.bookedTripDiscounts[0].value : 0;
				const milesInFlightDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.miles ? this.milesInFlightDiscount.miles : 0;
				const cashDiscountEquivalentOfMilesDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.cash ? this.milesInFlightDiscount.cash : 0;
				const flightMilesCostFromAPI = booked_trip.data.fare.flightCost && booked_trip.data.fare.flightCost.miles ? booked_trip.data.fare.flightCost.miles : 0;
				if (miles == 0 && (initialMGDiscount > 0 && cashDiscountEquivalentOfMilesDiscount > 0 && initialMGDiscount === cashDiscountEquivalentOfMilesDiscount)) {
					miles = milesInFlightDiscount;
					if(this.userMiles >= 0 || !this.isUserLoggedIn){
						cash = cash - initialMGDiscount;
					}
				} else if (miles > 0 && flightMilesCostFromAPI == 0 &&
					(initialMGDiscount > 0 && cashDiscountEquivalentOfMilesDiscount > 0 && initialMGDiscount === cashDiscountEquivalentOfMilesDiscount)) {
					miles += milesInFlightDiscount;
					if(this.userMiles >= 0 || !this.isUserLoggedIn){
						cash = cash - initialMGDiscount;
					}
				}
			}

			if (miles > 0) {
				this.totalBookingCashToPay = `${cash.toFixed(2)} ${currencyUnit}`;
				if(this.userMiles >= 0){
					this.totalBookingMilesToPay = `${miles.toFixed(0)} M`
				}
			} else {
				this.totalBookingCashToPay = `${cash.toFixed(2)} ${currencyUnit}`;
			}
		}
	}

	private INDRA_getAncillariesTotalPrice(currency) {
		// TAP ancillaries 
		let cashTotal = 0;
		let milesTotal = 0;

		if (this.ancillaries && this.ancillaries.length > 0) {
			this.ancillaries.forEach(ancillary => {
				cashTotal += (+ancillary.cost);
				milesTotal += (ancillary.payWithMiles ? +ancillary.points : 0);
			});
		}
		// cartrawler car rental
		if (this.bookedCarRentals && this.bookedCarRentals.length > 0) {
			this.bookedCarRentals.forEach(car => {
				cashTotal += car.price;
			});
		}
		// carbon offset
		if (this.carbonOffset) {
			cashTotal += this.carbonOffset.amount;
			this.taxCarbonSummary.push({ label: this.INDRA_getTranslation('priceBreakdown.text.carbonOffsetTax'), value: this.carbonOffset.extraInfo.totalTax});
			this.taxCarbonSummary.push({ label: this.INDRA_getTranslation('priceBreakdown.text.carbonOffsetCost'), value: this.carbonOffset.extraInfo.totalCost});
		}
		// danish guarantee fund
		if (this.danishGuaranteeFund) {
			cashTotal += this.danishGuaranteeFund.amount;
		}
		// chubb insurance
		if (this.insurance) {
			cashTotal += this.insurance.amount;
		}

		let priceStr = '';
		if (milesTotal > 0) {
			priceStr = `${milesTotal.toFixed(0)} M`;
		}
		if (cashTotal > 0) {
			if (priceStr.length > 0) priceStr += ' + '
			priceStr += `${cashTotal.toFixed(2)} ${this.currencyService.INDRA_getCurrencySymbol(currency).unit}`;
		}
		return priceStr;
	}

	private INDRA_computeOtherPrices() {
		return this.adminFee + this.ccFee;
	}

	private INDRA_getTotalDiscounts(booked_trip, hasVoucherOrPromocode, currency) {
		let totalDiscount;

		// override prices from API if has mgp1 discount AND mgp1 <= flight milesgo discount in store AND no promocode/voucher
		if (!hasVoucherOrPromocode) {
			const initialMGDiscount =
				this.bookedTripDiscounts && this.bookedTripDiscounts.length > 0 && this.bookedTripDiscounts[0] && this.bookedTripDiscounts[0].value ?
					this.bookedTripDiscounts[0].value : 0;
			const milesInFlightDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.miles ? this.milesInFlightDiscount.miles : 0;
			const cashDiscountEquivalentOfMilesDiscount = this.milesInFlightDiscount && this.milesInFlightDiscount.cash ? this.milesInFlightDiscount.cash : 0;
			if (initialMGDiscount > 0 && cashDiscountEquivalentOfMilesDiscount > 0 && cashDiscountEquivalentOfMilesDiscount >= initialMGDiscount && this.userMiles >= 0) {
				totalDiscount = `${initialMGDiscount.toFixed(2)} ${this.currencyService.INDRA_getCurrencySymbol(currency).unit}`
			}
		} else {
			if (booked_trip.data.fare.totalDiscount) {
				let cashPart = '';
				const milesPart = booked_trip.data.fare.totalDiscount.miles > 0 ? `${booked_trip.data.fare.totalDiscount.miles.toFixed(0)} M` : '';
				if (booked_trip.data.fare.totalDiscount.amount > 0 && booked_trip.data.fare.totalDiscount.miles > 0) {
					cashPart = `+ ${booked_trip.data.fare.totalDiscount.amount.toFixed(2)} ${this.currencyService.INDRA_getCurrencySymbol(booked_trip.data.fare.totalDiscount.currency).unit}`;
				} else if (booked_trip.data.fare.totalDiscount.amount > 0 && booked_trip.data.fare.totalDiscount.miles <= 0) {
					cashPart = `${booked_trip.data.fare.totalDiscount.amount.toFixed(2)} ${this.currencyService.INDRA_getCurrencySymbol(booked_trip.data.fare.totalDiscount.currency).unit}`;
				} else {
					cashPart = '';
				}
				totalDiscount = `${milesPart} ${cashPart}`;
			}
		}
		return totalDiscount;
	}

	private INDRA_getAncillaries(booked_trip, booked_trip_flights, hasStopover) {
		const itemsAdded = this.getAncillariesFromBasket(booked_trip);
		if (itemsAdded.length) {
			const ancillariesTemp = [];
			for (const i in itemsAdded) {
				let destination;
				const ancillaryDetail = this.ancillariesService.INDRA_getAncillaryConfig(itemsAdded[i].type);
				const flight = this.getFlightDetails(booked_trip_flights, itemsAdded[i]);
				if (hasStopover) {
					if (
						itemsAdded[i].type === ANCILLARY_PRODUCT_LOUNGE ||
						itemsAdded[i].type === ANCILLARY_PRODUCT_FAST_TRACK ||
						itemsAdded[i].type === ANCILLARY_PRODUCT_SEAT ||
						itemsAdded[i].type === ANCILLARY_PRODUCT_MEAL ||
						itemsAdded[i].type === ANCILLARY_PRODUCT_PREF_BOARD ||
						itemsAdded[i].type === ANCILLARY_PRODUCT_BAGGAGE || 
						(ANCILLARY_PRODUCT_PACKS.includes(itemsAdded[i].type) && !itemsAdded[i].flightBased)
					) {
						if (flight.idFlight === parseInt(itemsAdded[i].flightId)) {
							const ancillarySegment = flight.listSegment.find(segment => segment.idInfoSegment === parseInt(itemsAdded[i].segmentId));
							if (ancillarySegment) {
								destination = `${booked_trip.translate.locations[ancillarySegment.departureAirport].city} - ${booked_trip.translate.locations[ancillarySegment.arrivalAirport].city}`;
							}
						}
					} else {
						// for flight-based
						const flightsList = _.cloneDeep(booked_trip_flights);
						for (let x = 0; x < flightsList.length; x++) {
							if (flightsList[x].item.arrivalLocation.code == flight.lastSegment.arrivalAirport &&
								flightsList[x].item.departureLocation.code == flight.firstSegment.departureAirport) {
								destination = x + 1 == flightsList.length ? `${flightsList[x].item.departureLocation.city} - ${flightsList[x].item.arrivalLocation.city}` :
									`${flightsList[x].item.departureLocation.city} - ${flightsList[x + 1].item.arrivalLocation.city}`;
								break;
							}
						}
					}
				} else {
					let arr: any;
					if (itemsAdded[i].type === ANCILLARY_PRODUCT_LOUNGE || itemsAdded[i].type === ANCILLARY_PRODUCT_FAST_TRACK ||
						itemsAdded[i].type === ANCILLARY_PRODUCT_SEAT || itemsAdded[i].type === ANCILLARY_PRODUCT_MEAL ||
						itemsAdded[i].type === ANCILLARY_PRODUCT_PREF_BOARD || (ANCILLARY_PRODUCT_PACKS.includes(itemsAdded[i].type) && !itemsAdded[i].flightBased)) {
						const ancillarySegment = flight.listSegment.find(segment => segment.idInfoSegment === parseInt(itemsAdded[i].segmentId));
						destination = `${booked_trip.translate.locations[ancillarySegment.departureAirport].city} - ${booked_trip.translate.locations[ancillarySegment.arrivalAirport].city}`;
					} else {
						// for flight-based
						const origin = this.bookingService.INDRA_getLocation(flight.firstSegment.departureAirport);
						arr = this.bookingService.INDRA_getLocation(flight.lastSegment.arrivalAirport);
						destination = `${origin.city} - ${arr.city}`;
					}
				}

				let isPack = false;
				const includedAncillaries = [];
				if (
					ANCILLARY_PRODUCT_PACKS.includes(itemsAdded[i].type)
				) {
					isPack = true;
				}

				const ancillaryQuantity = itemsAdded[i].type !== EXTRAS_ANCILLARY_SEAT && itemsAdded[i].quantity ? itemsAdded[i].quantity : 1
				const ancillaryDetails = {
					name: ancillaryDetail.name,
					quantity: ancillaryQuantity,
					destination: destination,
					cost: itemsAdded[i].price * ancillaryQuantity,
					link: ancillaryDetail.action.route,
					flight: flight,
					icon: ancillaryDetail.icon,
					flightId: itemsAdded[i].flightId,
					segmentId: itemsAdded[i].segmentId,
					type: itemsAdded[i].type,
					payWithMiles: itemsAdded[i].spendPoints ? true : false,
					points: itemsAdded[i].points ? itemsAdded[i].points * ancillaryQuantity : 0,
					currency: this.currencyService.INDRA_getCurrencySymbol(itemsAdded[i].currency).unit,
					flightCardId: itemsAdded[i].flightCardId,
					code: itemsAdded[i].code,
					paxId: itemsAdded[i].paxId,
					emdTicket: itemsAdded[i].emdTicket,
					ssrTatto: itemsAdded[i].ssrTatto,
					translation: ancillaryDetail.translation,
					isPack: isPack,
				};
				if (this.ancillaries && this.ancillaries.length == 0) {
					this.ancillaries.push(ancillaryDetails);
					ancillariesTemp.push(ancillaryDetails);
				} else {
					let found = false;
					for (const x in this.ancillaries) {
						if (this.ancillaries[x].type == ancillaryDetails.type &&
							this.ancillaries[x].destination == ancillaryDetails.destination) {
							found = true;

							// additional logic to group flight-based ancillaries
							if (this.ancillaries[x].type === EXTRAS_ANCILLARY_ANIMAL && ancillaryDetails.type === EXTRAS_ANCILLARY_ANIMAL) {
								if ((ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_ANIMAL && anc.destination == ancillaryDetails.destination).length > 0) &&
									(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_ANIMAL && anc.paxId == ancillaryDetails.paxId &&
										anc.destination == ancillaryDetails.destination).length == 0)) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
									this.ancillaries[x].cost = this.ancillaries[x].cost + ancillaryDetails.cost;
									this.ancillaries[x].points = this.ancillaries[x].points + ancillaryDetails.points;
								}
								ancillariesTemp.push(ancillaryDetails);
							}
							else if (this.ancillaries[x].type === EXTRAS_ANCILLARY_EQUIPMENT && ancillaryDetails.type === EXTRAS_ANCILLARY_EQUIPMENT) {
								if ((ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_EQUIPMENT && anc.destination == ancillaryDetails.destination).length > 0) &&
									(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_EQUIPMENT && anc.paxId == ancillaryDetails.paxId &&
										anc.code == ancillaryDetails.code && anc.destination == ancillaryDetails.destination).length == 0)) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
									this.ancillaries[x].cost = this.ancillaries[x].cost + ancillaryDetails.cost;
									this.ancillaries[x].points = this.ancillaries[x].points + ancillaryDetails.points;
								}
								ancillariesTemp.push(ancillaryDetails);
							}
							else if (this.ancillaries[x].type === EXTRAS_ANCILLARY_MUSICAL && ancillaryDetails.type === EXTRAS_ANCILLARY_MUSICAL) {
								if ((ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_MUSICAL && anc.destination == ancillaryDetails.destination).length > 0) &&
									(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_MUSICAL && anc.paxId == ancillaryDetails.paxId &&
										anc.code == ancillaryDetails.code && anc.destination == ancillaryDetails.destination).length == 0)) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
									this.ancillaries[x].cost = this.ancillaries[x].cost + ancillaryDetails.cost;
									this.ancillaries[x].points = this.ancillaries[x].points + ancillaryDetails.points;
								}
								ancillariesTemp.push(ancillaryDetails);
							}
							else if (this.ancillaries[x].type === EXTRAS_ANCILLARY_BAG && ancillaryDetails.type === EXTRAS_ANCILLARY_BAG) {
								if ((ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_BAG && anc.destination == ancillaryDetails.destination).length > 0) &&
									(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_BAG && anc.paxId == ancillaryDetails.paxId &&
										anc.code == ancillaryDetails.code && anc.destination == ancillaryDetails.destination).length == 0)) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
									this.ancillaries[x].cost = this.ancillaries[x].cost + ancillaryDetails.cost;
									this.ancillaries[x].points = this.ancillaries[x].points + ancillaryDetails.points;
								} else {
									if (ancillaryDetails.code === SSR_CODE_BAGGAGE_ADDITIONAL_BAG &&
										(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_BAG && anc.destination == ancillaryDetails.destination &&
											anc.paxId == ancillaryDetails.paxId && anc.code == ancillaryDetails.code).length > 0) &&
										(ancillariesTemp.filter(anc => anc.type === EXTRAS_ANCILLARY_BAG && anc.destination == ancillaryDetails.destination &&
											anc.paxId == ancillaryDetails.paxId && anc.code == ancillaryDetails.code && ((anc.emdTicket && anc.emdTicket == ancillaryDetails.emdTicket) ||
												(anc.ssrTatto && anc.ssrTatto == ancillaryDetails.ssrTatto))).length == 0)) {
										this.ancillaries[x].quantity = this.ancillaries[x].quantity + ancillaryDetails.quantity;
										this.ancillaries[x].cost = this.ancillaries[x].cost + ancillaryDetails.cost;
										this.ancillaries[x].points = this.ancillaries[x].points + ancillaryDetails.points;
									}
								}
								ancillariesTemp.push(ancillaryDetails);
							}

							else {
								if (this.ancillaries[x].type !== EXTRAS_ANCILLARY_ANIMAL && ancillaryDetails.type !== EXTRAS_ANCILLARY_ANIMAL &&
									this.ancillaries[x].type !== EXTRAS_ANCILLARY_EQUIPMENT && ancillaryDetails.type !== EXTRAS_ANCILLARY_EQUIPMENT &&
									this.ancillaries[x].type !== EXTRAS_ANCILLARY_MUSICAL && ancillaryDetails.type !== EXTRAS_ANCILLARY_MUSICAL &&
									this.ancillaries[x].type !== EXTRAS_ANCILLARY_BAG && ancillaryDetails.type !== EXTRAS_ANCILLARY_BAG) {
									this.ancillaries[x].quantity = this.ancillaries[x].quantity + 1;
									this.ancillaries[x].cost = this.ancillaries[x].cost + ancillaryDetails.cost;
									this.ancillaries[x].points = this.ancillaries[x].points + ancillaryDetails.points;
								}
							}
						}
					}
					if (!found) {
						this.ancillaries.push(ancillaryDetails);
						ancillariesTemp.push(ancillaryDetails);
					}

				}
			}

		}
	}

	private getAncillariesFromBasket(booked_trip) {
		const ancillaries = [];
		if (booked_trip.data.ancillaryBasket && booked_trip.data.ancillaryBasket.selectedAncillaries) {
			Object.keys(booked_trip.data.ancillaryBasket.selectedAncillaries).forEach(type => {
				const items: [] = booked_trip.data.ancillaryBasket.selectedAncillaries[type].length > 0 ?
					booked_trip.data.ancillaryBasket.selectedAncillaries[type] : [booked_trip.data.ancillaryBasket.selectedAncillaries[type]];
				items.forEach((item: any) => {
					let ancillary: any = {};
					ancillary.type = item.ancillaryType;
					if (item.journey && item.journey.length) {
						item.journey.forEach((flight: any) => {
							const details: any = {
								flightId: flight.flightId,
								segmentId: flight.segmentId,
								flightBased: flight.flightBased
							};
							if (flight.passengers && flight.passengers.length) {
								flight.passengers.forEach((pax: any) => {
									details.paxId = pax.paxId;
									if (pax.ancillaryInfo && pax.ancillaryInfo.length) {
										pax.ancillaryInfo.forEach((info: any) => {

											// note: filter was added because backend has an issue with price and ssrTatto
											// of flight-based ancillaries on indirect flights (instead of having price/points for every segment,
											// there are segments where ancillary price/points is 0, also ancillary in each segmens have different ssrTatto value. 
											// The correct structure is that flight-based ancillaries spanning multiple segments should have the same ssrTattoo value and
											// have the same price)

											if (item.ancillaryType === EXTRAS_ANCILLARY_BAG ||
												item.ancillaryType === EXTRAS_ANCILLARY_EQUIPMENT ||
												item.ancillaryType === EXTRAS_ANCILLARY_MUSICAL ||
												item.ancillaryType === EXTRAS_ANCILLARY_ANIMAL ||
												(ANCILLARY_PRODUCT_PACKS.includes(item.ancillaryType) && flight.flightBased)) {
												if (info && (info.price > 0 || info.points > 0)) {
													ancillary = { ...ancillary, ...details, ...info };
													ancillaries.push(ancillary);
												}
											} else {
												ancillary = { ...ancillary, ...details, ...info };
												if (item.ancillaryType === EXTRAS_ANCILLARY_SEAT) {
													ancillary.type = item.ancillaryType;
												}
												ancillaries.push(ancillary);
											}
										});
									}
								});
							}
						});
					}
				});
			});
		}
		return ancillaries;
	}

	private getFlightDetails(flightDetails, ancillaryData) {
		let flightData: any;
		for (const i in flightDetails) {
			if (flightDetails[i].type == 'flight') {
				if (
					ancillaryData.type === ANCILLARY_PRODUCT_LOUNGE ||
					ancillaryData.type === ANCILLARY_PRODUCT_FAST_TRACK ||
					ancillaryData.type === ANCILLARY_PRODUCT_SEAT ||
					ancillaryData.type === ANCILLARY_PRODUCT_MEAL ||
					ancillaryData.type === ANCILLARY_PRODUCT_PREF_BOARD ||
					ancillaryData.type === ANCILLARY_PRODUCT_BAGGAGE
				) {
					if (flightDetails[i].item.details.idFlight == parseInt(ancillaryData.flightId) &&
						flightDetails[i].item.details.listSegment.filter(segment => segment.idInfoSegment == parseInt(ancillaryData.segmentId)).length > 0) {
						flightData = Object.assign({}, flightDetails[i].item.details);
						break;
					}
				} else {
					if (flightDetails[i].item.details.idFlight == parseInt(ancillaryData.flightId)) {
						flightData = Object.assign({}, flightDetails[i].item.details);
						break;
					}
				}
			}
		}
		return flightData;
	}

	INDRA_printExtraOldCost(extra) {
		return (+extra.oldCost).toFixed(2) + ' ' + extra.currency;
	}

	INDRA_printExtraCost(extra) {
		if (extra.payWithMiles) {
			return extra.points.toFixed(0) + ' M';
		} else {
			return (+extra.cost).toFixed(2) + ' ' + extra.currency;
		}
	}

	INDRA_openAncillarySidebar(ancillary) {
		const {
			link: sidebarRoute,
			flight: flightDetails,
		} = ancillary


		let flightId = flightDetails.assignedFlightId;
		let options: any = {
			flight: flightId,
		};
		// this.bookedTrip.stopover ? flightId = flightCardId : flightId = flightDetails.assignedFlightId;

		if (ancillary.isPack) {
			options.packId = ancillary.type;
			options.isAdded = true;
		}


		if (!this.isDupe) {
			if (this.isBookingAlreadyCreated) {
				options.isBookingCreated = this.isBookingAlreadyCreated;
			}

			this.sidebarService.openSidebar([sidebarRoute, options]);
		}
	}

	INDRA_handleDetailsClick(flight) {
		this.store.dispatch(new FlightResultActions.PutSelectedFlightAction(Object.assign(new Flight(null, null, null), flight)));
		this.sidebarService.openSidebar(['flight-details', { flight: flight.listSegment[0].flightNumber, mode: 'search' }]);
	}

	INDRA_handleFareAndTaxes() {
		let fareTaxesParams = {
			isDupe: this.isDupe,
			isTTTBookingForCompletion: this.isTTTBookingForCompletion
		};

		if (!this.isDupe && this.isTTTBookingForCompletion) {
			fareTaxesParams['pnr'] = this.pnr
		}

		this.sidebarService.openSidebar(['fare-and-taxes', fareTaxesParams]);
	}

	INDRA_handleBackToChangeFlight() {
		this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslation('priceBreakdown.text.backToSelection')));
		this.store.dispatch(new ConfirmModalActions.PutBodyMsg(this.INDRA_getTranslation('priceBreakdown.text.ifYouContinue')));
		this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslation('priceBreakdown.text.dontLeavePage')));
		this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslation('priceBreakdown.text.chooseFlightsAgain')));
		this.modalService.assignComponent(INDRAConfirmModalComponent);
		this.modalService.open();

		this.modalService.isOpen
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((value) => {
				if (!value) {
					if (this.confirmModalCallback === 'ok') {
						this.store.dispatch(new ConfirmModalActions.ResetAction());
						if (this.hasStopover) {
							this.router.navigate(['/booking/flights-stopover']);
						} else {
							if (this.tripType === TRIP_TYPE_MULTICITY_CODE) {
								this.router.navigate(['/booking/flights-multicity']);
							} else {
								this.router.navigate(['/booking/flights']);
							}
						}

						this.closeSidebar();
						this.INDRA_clearBookedTrip();
					}
				}
			});
	}

	/**
	 * Clear selected flights
	 */
	INDRA_clearBookedTrip() {
		const auxArray: Array<BookingStep> = [];
		this.bookingSteps.forEach(step => { auxArray.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })); });

		const booked_trip = Object.assign(new BookedTrip([], this.bookedTrip.pnr, this.bookedTrip.booking_type), this.bookedTrip);
		booked_trip.emptyFlights();

		this.store.dispatch(new BookedTripActions.PutBookedTripAction(booked_trip));
		this.store.dispatch(new BookingStepActions.PutStepsAction(auxArray));
		this.store.dispatch(new BookingStepActions.PutCurrentStepAction(0));
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	private closeSidebar() {
		this.sidebarService.closeSidebar();
	}

	INDRA_isUserLoggedIn() {
		return this.userInfo ? true : false;
	}

	showLoginModal() {
		this.modalService.assignComponent(INDRALoginModalComponent);
		this.modalService.open();
	}

	INDRA_isNormalBookingOrActiveTTT(bookedTrip) {
		return (!bookedTrip || !bookedTrip.time_to_think || !bookedTrip.time_to_think.status || bookedTrip.time_to_think.status === TTT_STATUS_ACTIVE);
	}

	INDRA_handleSignUp() {
		this.sidebarService.openSidebar(['sign-up']);
	}

	INDRA_handleVoucherOrPromocode() {
		if (!this.isDupe && !this.triggerHppRedFlag) {
			this.sidebarService.openSidebar(['voucher-or-promocode', { isBookingCreated: this.isBookingAlreadyCreated }]);
		}
	}

	INDRA_setThirdPartyExtras(booked_trip) {
		// Carbon Offset
		if (booked_trip.externalReservations.CARBON_OFFSET && booked_trip.externalReservations.CARBON_OFFSET.length > 0 &&
			booked_trip.externalReservations.CARBON_OFFSET[0]) {
			this.carbonOffset = booked_trip.externalReservations.CARBON_OFFSET[0];
			this.carbonOffsetCurrency = this.currencyService.INDRA_getCurrencySymbol(this.carbonOffset.currency).unit;
		}

		// Insurance
		if (booked_trip.externalReservations.CHUBB && booked_trip.externalReservations.CHUBB.length > 0 &&
			booked_trip.externalReservations.CHUBB[0]) {
			this.insurance = booked_trip.externalReservations.CHUBB[0];
			this.insuranceCurrency = this.currencyService.INDRA_getCurrencySymbol(this.insurance.currency).unit;
		}

		// Danish Guarantee Fund
		if (booked_trip.externalReservations.DANISH_FUND && booked_trip.externalReservations.DANISH_FUND.length > 0 &&
			booked_trip.externalReservations.DANISH_FUND[0]) {
			this.danishGuaranteeFund = booked_trip.externalReservations.DANISH_FUND[0];
			this.danishFundCurrency = this.currencyService.INDRA_getCurrencySymbol(this.danishGuaranteeFund.currency).unit;
		}

		// Booking.com Hotels
		if (booked_trip.externalReservations.BOOKING && booked_trip.externalReservations.BOOKING.length > 0) {
			let totalPrice = 0;
			booked_trip.externalReservations.BOOKING.forEach(data => {
				const hotel = {
					routeParam: { city: data.extraInfo ? this.bookingService.INDRA_getLocation(data.extraInfo.city).city : '' },
					value: data.amount,
					currency: this.currencyService.INDRA_getCurrencySymbol(data.currency).unit
				};
				this.bookedHotels.push(hotel);
				this.bookedTripExtrasCurrency = hotel.currency;
				totalPrice += hotel.value;
			});
			this.bookedTripExtrasTotalPrice = totalPrice;
		}

		// Cartrawler Car Rentals
		if (booked_trip.externalReservations.CARTRAWLER && booked_trip.externalReservations.CARTRAWLER.length > 0) {
			this.bookedCarRentals = [];
			booked_trip.externalReservations.CARTRAWLER.forEach(data => {
				this.bookedCarRentals.push({
					location: this.bookingService.INDRA_getLocation(data.extraInfo.city).city,
					price: data.amount,
					currency: this.currencyService.INDRA_getCurrencySymbol(data.currency).unit
				});
				this.bookedCarRentalTotalPrice = this.bookedCarRentalTotalPrice + data.amount;
			});
		}
	}

	INDRA_handleCarbonOffset() {
		if (!this.isDupe) {
			if (this.isBookingAlreadyCreated) {
				this.sidebarService.openSidebar(['carbon-offset', { isBookingCreated: this.isBookingAlreadyCreated }]);
			} else {
				this.sidebarService.openSidebar(['carbon-offset']);
			}
		}
	}

	INDRA_danishGuaranteeFund() {
		if (!this.isDupe) {
			if (this.isBookingAlreadyCreated) {
				this.sidebarService.openSidebar(['danish-guarantee-fund', { isBookingCreated: this.isBookingAlreadyCreated }]);
			} else {
				this.sidebarService.openSidebar(['danish-guarantee-fund']);
			}
		}
	}

	INDRA_handleInsurance(insurance) {
		if (!this.isDupe) {
			if (this.isBookingAlreadyCreated) {
				this.sidebarService.openSidebar(['travel-insurance', { isBookingCreated: this.isBookingAlreadyCreated }], [insurance]);
			} else {
				this.sidebarService.openSidebar(['travel-insurance'], [insurance]);
			}
		}
	}

	INDRA_getPlanDescription(key: string) {
		if (key) {
			const label = this.ibeAdminService.getTranslationValue(`${this.translationInsurance.MODULE}.${this.translationInsurance.PROVIDER}.${this.translationInsurance.PLAN}.${key}`);
			return label;
		}
		return '';
	}

	INDRA_showExtras() {
		return (this.booked_trip_flights.length > 0 && ((this.ancillaries && this.ancillaries.length > 0) || this.danishGuaranteeFund ||
			this.carbonOffset || this.extra_stopover.length > 0 || this.insurance || this.bookedCarRentals.length > 0)) ? true : false;
	}

	INDRA_setStopoverExtras(booked_trip, currency) {
		if (booked_trip.externalReservations.SO_AIRPORT_TRANSFER && booked_trip.externalReservations.SO_AIRPORT_TRANSFER.length > 0 &&
			booked_trip.externalReservations.SO_AIRPORT_TRANSFER[0]) {
			const stopoverExtra = this.bookedTripExtras && this.bookedTripExtras.length > 0 ?
				this.bookedTripExtras.find(extra => extra.type == 'airport-transfers') : null;
			this.INDRA_createStopoverExtra(
				stopoverExtra,
				this.STOPOVER_LINKS.find(extra => extra.id == 'airport-transfers'),
				booked_trip.externalReservations.SO_AIRPORT_TRANSFER[0],
				booked_trip.externalReservations.SO_AIRPORT_TRANSFER[0].stopOverInfo.SO_AIRPORT_TRANSFER.amount,
				booked_trip.externalReservations.SO_AIRPORT_TRANSFER[0].stopOverInfo.SO_AIRPORT_TRANSFER.currency);
		}

		if (booked_trip.externalReservations.SO_LISBON_DISCOUNT && booked_trip.externalReservations.SO_LISBON_DISCOUNT.length > 0 &&
			booked_trip.externalReservations.SO_LISBON_DISCOUNT[0]) {
			const stopoverExtra = this.bookedTripExtras && this.bookedTripExtras.length > 0 ?
				this.bookedTripExtras.find(extra => extra.type == 'lisboa-card') : null;
			this.INDRA_createStopoverExtra(
				stopoverExtra,
				this.STOPOVER_LINKS.find(extra => extra.id == 'lisboa-card'),
				booked_trip.externalReservations.SO_LISBON_DISCOUNT[0],
				booked_trip.externalReservations.SO_LISBON_DISCOUNT[0].stopOverInfo.SO_LISBON_DISCOUNT.amount,
				booked_trip.externalReservations.SO_LISBON_DISCOUNT[0].stopOverInfo.SO_LISBON_DISCOUNT.currency);
		}

		if (booked_trip.externalReservations.SO_SIGHTSEEING_TOUR && booked_trip.externalReservations.SO_SIGHTSEEING_TOUR.length > 0 &&
			booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0]) {
			const stopoverExtra = this.bookedTripExtras && this.bookedTripExtras.length > 0 ?
				this.bookedTripExtras.find(extra => extra.type == 'sightseeing-tours') : null;
			let extraAncillaryAmount = 0;
			let extraCurrency = currency;
			if (booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_1 &&
				booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_1.amount) {
				extraAncillaryAmount += booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_1.amount;
				if (booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_1.currency) {
					extraCurrency = booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_1.currency;
				}
			}
			if (booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_2 &&
				booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_2.amount) {
				extraAncillaryAmount += booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_2.amount;
				if (booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_2.currency) {
					extraCurrency = booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0].stopOverInfo.SO_SIGHTSEEING_TOUR_OPTION_2.currency;
				}
			}
			this.INDRA_createStopoverExtra(
				stopoverExtra,
				this.STOPOVER_LINKS.find(extra => extra.id == 'sightseeing-tours'),
				booked_trip.externalReservations.SO_SIGHTSEEING_TOUR[0],
				extraAncillaryAmount,
				extraCurrency);
		}

		if (booked_trip.externalReservations.SO_HOTEL && booked_trip.externalReservations.SO_HOTEL.length > 0) {
			const filteredExtras = this.bookedTripExtras && this.bookedTripExtras.length > 0 ? this.bookedTripExtras.find(extra => extra.type === 'hotel') : null;
			const hotels = filteredExtras && filteredExtras.data ? filteredExtras.data : null;
			if (hotels && hotels.length > 0) {
				let totalPrice = 0;
				booked_trip.externalReservations.SO_HOTEL.forEach(hotel => {
					for (let i = 0; i < hotels.length; i++) {
						const hotelInfo = hotel.stopOverInfo[hotels[i].stopoverInfoId];
						if (hotelInfo) {
							const stopoverHotel = {
								routeParam: {
									city: hotel.idReservation ?
										this.bookingService.INDRA_getLocation(hotel.idReservation).city : ''
								},
								value: hotelInfo.amount,
								currency: this.currencyService.INDRA_getCurrencySymbol(hotelInfo.currency).unit
							};
							this.bookedHotels.push(stopoverHotel);
							totalPrice += hotelInfo.amount;
							this.bookedTripExtrasCurrency = stopoverHotel.currency;
							break;
						}
					}
				});
				this.bookedTripExtrasTotalPrice += totalPrice;
			}
		}
	}

	private INDRA_createStopoverExtra(stopoverExtra, extraDetails, extraAncillary, extraAncillaryAmount, extraCurrency) {
		if (stopoverExtra) {
			this.extra_stopover.push(Object.assign({}, stopoverExtra, {
				icon: extraDetails.icon,
				action: extraDetails.action,
				label: extraDetails.label,
				stopoverCityName: this.booked_trip.translate.locations[extraAncillary.idReservation].city,
				value: extraAncillaryAmount,
				currency: this.currencyService.INDRA_getCurrencySymbol(extraCurrency).unit
			}));
		} else {
			this.extra_stopover.push(Object.assign({}, {
				icon: extraDetails.icon,
				action: extraDetails.action,
				label: extraDetails.label,
				stopoverCityName: this.booked_trip.translate.locations[extraAncillary.idReservation].city,
				value: extraAncillaryAmount,
				currency: this.currencyService.INDRA_getCurrencySymbol(extraCurrency).unit
			}));
		}
	}

	INDRA_handleOpenSidebar(feature) {
		if (!this.isDupe) {
			if (this.isBookingAlreadyCreated) {
				this.sidebarService.openSidebar([feature.action.route, { isBookingCreated: this.isBookingAlreadyCreated }], feature.selectedExtra);
			} else {
				this.sidebarService.openSidebar([feature.action.route], feature.selectedExtra);
			}
		}
	}

  INDRA_isNonZeroPriceFlight(): boolean {
    return !!this.booked_trip_flights && this.booked_trip_flights.every((flight) => {
      return flight.item.isNonZeroPrice;
    });
  }

	/**
	 * Toggle the expanded/collapsed state;
	 */
	handleToggle() {
		if (this.state === 'expanded') {
			this.state = 'collapsed';
		} else {
			this.state = 'expanded';
		}
	}
}
